import * as R from "ramda";
import { useStore } from "./index";
import steps, { getSchemaByName, getStoreKeyByName } from "../Steps";

const _addSuccessSteps = name => {
  const successSteps = useStore.getState().successSteps
  const addSuccessSteps = useStore.getState().addSuccessSteps
  if(!successSteps.includes(name)) {
    addSuccessSteps(name)
  }
}

const handleWizardStep = step => {
  if(step.name === 'preview') {
    return
  }
  const setCurrentStep = useStore.getState().setCurrentStep
  setCurrentStep(step)
}

const handleWizardNextStep = () => {
  const currentStep = useStore.getState().currentStep
  const setCurrentStep = useStore.getState().setCurrentStep
  const resetAlert = useStore.getState().resetAlert

  const currentStepIndex = R.findIndex(R.propEq('name', currentStep.name))(steps);
  const nextStep = steps[currentStepIndex + 1]
  if(nextStep) {
    if(nextStep.name !== 'preview') {
      setCurrentStep(nextStep)
    }
    _addSuccessSteps(currentStep.name)
    resetAlert()
  }
}

const handleWizardPrevStep = () => {
  const currentStep = useStore.getState().currentStep
  const setCurrentStep = useStore.getState().setCurrentStep

  const currentStepIndex = R.findIndex(R.propEq('name', currentStep.name))(steps);
  const prevStep = steps[currentStepIndex - 1]
  if(prevStep) {
    setCurrentStep(prevStep)
  }
}

const handleWizardPreviewStep = () => {
  const setCurrentStep = useStore.getState().setCurrentStep
  const setAlert = useStore.getState().setAlert

  const invalidateStep = getInvalidateStep()
  let step
  if(invalidateStep) {
    step = invalidateStep
    setAlert({ body: 'Please complete all steps before generating Privacy Policy', type: 'warning' })
  } else {
    step = steps.find(step => step.name === 'preview')
  }
  setCurrentStep(step)
}

const getInvalidateStep = () => {
  const state = useStore.getState()

  let invalidateStep;

  steps.forEach(step => {
    const key = getStoreKeyByName(step.name)
    if(key) {
      const data = state[key]
      if(data) {
        const schema = getSchemaByName(step.name)
        const isValid = schema.isValidSync(data)
        if(isValid) {
          _addSuccessSteps(step.name)
        } else {
          if(!invalidateStep) {
            invalidateStep = step
          }
        }
      }
    }
  })
  return invalidateStep
}

const handleWizardReset = () => {
  const resetCurrentStep = useStore.getState().resetCurrentStep
  const resetSuccessSteps = useStore.getState().resetSuccessSteps
  const resetAlert = useStore.getState().resetAlert
  const resetContactsFormValue = useStore.getState().resetContactsFormValue
  const resetExtrasFormValue = useStore.getState().resetExtrasFormValue
  const resetExtrasFormData = useStore.getState().resetExtrasFormData
  const resetInformationFormValue = useStore.getState().resetInformationFormValue
  const resetInformationFormData = useStore.getState().resetInformationFormData
  const resetUsageFormValue = useStore.getState().resetUsageFormValue
  const resetUsageFormData = useStore.getState().resetUsageFormData

  resetCurrentStep()
  resetSuccessSteps()
  resetAlert()
  resetContactsFormValue()
  resetExtrasFormValue()
  resetExtrasFormData()
  resetInformationFormValue()
  resetInformationFormData()
  resetUsageFormValue()
  resetUsageFormData()
}

const actions = {
  handleWizardStep,
  handleWizardNextStep,
  handleWizardPrevStep,
  handleWizardPreviewStep,
  handleWizardReset
}

export default actions